import { PackageExportReadyMessage } from "@app/catalog/components/project/messages/package-export-ready-message/package-export-ready.message";
import { PackageExportStartedMessage } from "@app/catalog/components/project/messages/package-export-started-message/package-export-started.message";
import { ToastLevel } from "@app/components";
import { Notification } from "@app/shared";


@Notification({
    name: 'PackageExportStartedNotification'
})
export class PackageExportStartedNotification {
    public packageName: string;

    public getMessage(){
       return { message: new PackageExportStartedMessage(this.packageName), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}


@Notification({
    name: 'PackageExportReadyNotification'
})
export class PackageExportReadyNotification {
    public packageName: string;
    public url: string;

    public getMessage(){
       return { message: new PackageExportReadyMessage(this.packageName, this.url), id: this['id'], createdDate: this['createdDate'], isDismissable: this['isDismissable'], sender: this['sender'], level: ToastLevel.Information };
    }
}